export const initialLabels = [
  "tix_search_form_flight_tickets",
  "tix_search_form_hotels",
  "tix_search_form_return",
  "tix_search_form_oneway",
  "tix_search_form_multicity",
  "tix_search_form_flight_type",
  "tix_search_form_search_flights",
  "tix_search_form_departure",
  "tix_search_form_destination",
  "tix_search_form_departure_date",
  "tix_search_form_return_date",
  "tix_search_form_continue",
  "tix_search_form_when",
  "tix_search_form_passengers",
  "tix_search_form_class_economy",
  "tix_search_form_departure_title",
  "tix_search_form_destination_title",
  "tix_search_form_flights_calendar_title",
  "tix_search_form_flights_extended_search_title",
  "tix_search_form_hotels_calendar_title",
  "tix_search_form_hotels_rooms_title",
  "tix_search_form_hotels_autocomplete_title",
  "tix_search_form_search_hotels",
  "tix_search_form_location",
  "tix_search_form_from_date",
  "tix_search_form_to_date",
  "tix_search_form_location_title",
  "tix_search_form_room",
  "tix_search_form_add_another_room",
  "tix_search_form_adults",
  "tix_search_form_adult",
  "tix_search_form_age",
  "tix_search_form_children",
  "tix_search_form_child",
  "tix_search_form_class_premiumeconomy",
  "tix_search_form_class_business",
  "tix_search_form_class_first",
  "tix_search_form_no_preference",
  "tix_search_form_adults_age",
  "tix_search_form_children_age",
  "tix_search_form_select_child_age",
  "tix_search_form_infants_age",
  "tix_search_form_infants",
  "tix_search_form_cabin_class",
  "tix_search_form_cabin_class_subtitle",
  "tix_search_form_ready",
  "tix_search_form_autocomplete_country",
  "tix_search_form_autocomplete_city",
  "tix_search_form_autocomplete_region",
  "tix_search_form_err_flights_search_form_global",
  "tix_search_form_err_hotels_search_form_global",
  "tix_search_form_err_empty_fiels",
  "tix_search_form_err_adults_gt_0",
  "tix_search_form_err_passengers_amount_gt_9",
  "tix_search_form_err_infants_more_than_adults",
  "tix_search_form_err_departure_is_empty",
  "tix_search_form_err_departure_date_is_empty",
  "tix_search_form_err_departure_date_is_from_past",
  "tix_search_form_err_latest_date",
  "tix_search_form_err_destination_is_empty",
  "tix_search_form_err_dep_des_the_same",
  "tix_search_form_err_dep_des_the_same",
  "tix_search_form_err_check_in_date_empty",
  "tix_search_form_err_check_in_date_from_past",
  "tix_search_form_err_latest_date",
  "tix_search_form_err_check_out_date_empty",
  "tix_search_form_err_check_out_date_from_past",
  "tix_search_form_err_latest_date",
  "tix_search_form_err_hotel_dates_max_period_exceeded",
  "tix_search_form_err_hotel_location_code_empty",
  "tix_search_form_hotel_location_code_empty",
  "tix_search_form_perk_1",
  "tix_search_form_perk_2",
  "tix_search_form_perk_3",
  "tix_search_form_search_flights",
  "tix_search_form_search_hotels",
  "tix_search_form_rooms",
  "tix_search_form_flights_select_return_date",
  "tix_search_form_flights_select_departure_date",
  "tix_search_form_hotels_select_checkout_date",
  "tix_search_form_hotels_select_checkin_date",
  "tix_search_form_mobile_modal_flight_calendar_from_title",
  "tix_search_form_mobile_modal_flight_calendar_to_title",
  "tix_search_form_mobile_modal_flight_departure_title",
  "tix_search_form_mobile_modal_flight_destination_title",
  "tix_search_form_flights_extended_search_mobile_modal_title",
  "tix_search_form_mobile_modal_hotel_destination_title",
  "tix_search_form_mobile_modal_hotel_calendar_from_title",
  "tix_search_form_mobile_modal_hotel_calendar_to_title",
  "tix_search_form_mobile_modal_hotels_rooms_title",
  "tix_search_form_hotels_search_form_child_age_err",
  "tix_search_form_packages",
  "tix_search_form_search_packages",
  "tix_search_form_package_departure_date",
  "tix_search_form_package_return_date",
  "tix_search_form_err_packages_search_form_global",
  "tix_search_form_packages_calendar_title",
  "tix_search_form_packages_departure_autocomplete_title",
  "tix_search_form_packages_departure_autocomplete_placeholder",
  "tix_search_form_packages_destination_autocomplete_title",
  "tix_search_form_packages_destination_autocomplete_placeholder",
  "tix_search_form_mobile_modal_packages_calendar_departure_title",
  "tix_search_form_mobile_modal_packages_calendar_return_title",
  "tix_search_form_err_packages_search_form_global",
  "tix_search_form_err_package_departure_airport_is_empty",
  "tix_search_form_err_package_destination_is_empty",
  "tix_search_form_err_return_date_is_empty",
  "tix_search_form_err_return_date_is_from_past",
  "tix_search_form_err_package_dates_max_period_exceeded",
  "tix_search_form_tab_packages",
];
